export default "__VITE_ASSET__FZKWxX5o__"